import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useConfig from "./useConfig";

/**
 * i18nを管理するカスタムフック
 * configから取得した言語設定に基づいて言語を切り替える
 */
function useI18n() {
  const { i18n } = useTranslation();
  const { config } = useConfig();

  useEffect(() => {
    // configから言語設定を取得
    const language = config?.language;

    // 言語設定が存在し、現在の言語と異なる場合は言語を切り替える
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [config, i18n]);

  return {
    i18n,
    changeLanguage: (lng: string) => i18n.changeLanguage(lng),
    currentLanguage: i18n.language,
  };
}

export default useI18n;
